// extracted by mini-css-extract-plugin
module.exports = {"view":"styles_view__2EKkO","select":"styles_select__22k3I"};